import PathwayList from '../pathways/PathwayList';
import SystemList from '../systems/SystemList';
import ListPane from './ListPane';
import featureConfig from '@/featureConfig';

const BuildDropdownContent = () => (
  <ListPane>
    <PathwayList />
    {featureConfig.manageSystems && <SystemList />}
  </ListPane>
);

export default BuildDropdownContent;
